// extracted by mini-css-extract-plugin
module.exports = {"buttonGrp":"StartPanel_buttonGrp__3g45_","enabled":"StartPanel_enabled__wXGgu"};